import React, { ClassAttributes, HTMLAttributes } from 'react';

export const TableBody = (
  props: JSX.IntrinsicAttributes &
    ClassAttributes<HTMLTableSectionElement> &
    HTMLAttributes<HTMLTableSectionElement>,
) => <tbody {...props} />;
